{ "compressionlevel":-1,
 "editorsettings":
    {
     "export":
        {
         "format":"json",
         "target":"test1.json"
        }
    },
 "height":10,
 "infinite":false,
 "layers":[
        {
         "data":[2, 2, 2, 64, 64, 9, 64, 64, 64, 64, 2, 63, 2, 2, 15, 3, 64, 64, 64, 64, 2, 2, 2, 64, 64, 2, 64, 64, 64, 64, 64, 2, 64, 64, 64, 2, 64, 64, 64, 64, 64, 2, 64, 64, 64, 3, 64, 64, 64, 64, 12, 3, 2, 2, 2, 2, 2, 3, 2, 10, 64, 64, 64, 64, 64, 2, 64, 64, 64, 64, 64, 64, 64, 64, 64, 17, 64, 64, 64, 64, 64, 64, 64, 64, 64, 3, 64, 64, 64, 64, 64, 64, 64, 64, 64, 11, 64, 64, 64, 64],
         "height":10,
         "id":1,
         "name":"tiles",
         "opacity":1,
         "type":"tilelayer",
         "visible":true,
         "width":10,
         "x":0,
         "y":0
        }],
 "nextlayerid":2,
 "nextobjectid":1,
 "orientation":"orthogonal",
 "renderorder":"right-down",
 "tiledversion":"1.6.0",
 "tileheight":32,
 "tilesets":[
        {
         "firstgid":1,
         "source":"tileset.tsx"
        }],
 "tilewidth":32,
 "type":"map",
 "version":"1.6",
 "width":10
}